import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // 페이지가 바뀔 때마다 스크롤을 맨 위로 이동
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

export default ScrollToTop;
